export enum AdvisoryTrancheModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
